
import React, { useState } from 'react';

import { DataGrid, Button, NotificationList, Text } from 'quanta-ui';

import { useQuery, useMutation } from '@apollo/client';

import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
import { ModalSendEmail } from 'quanta-flows/modules/quote/health';
import { ModalSendSms } from 'quanta-flows/modules/quote/health';
import { GetFieldUserName } from 'quanta-flows/modules/quote/health';

import {
  CUSTOMER_DROPDOWN_DETAILS,
  // QUERY_STATE,
  SAVE_QUOTE,
  SEND_QUOTE_EMAIL_ALERT,
  SEND_QUOTE_PDF,
  SEND_QUOTE_SMS_ALERT,
  INTERMEDIARY_LIST
} from 'quanta-flows/modules/quote/health';

 import {QUERY_STATE} from '../queries'
import {
  //  updateHealthQuote,
  updateQuotationDetails } from 'quanta-flows/modules/quote/health/state';
  import { updateHealthQuote } from 'quanta-flows/modules/quote/health/state';
import {
  faSave, 
  faSpinner,
  faExclamationTriangle,
  faCheck,
  faEnvelope,
  faSms,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalSaveQuote from './modal-save-quote';
// import { ModalSaveQuote } from 'quanta-flows/modules/quote/health';
import { useMutationQuery } from 'quanta-flows';

export default function QuoteSummary({ productCode, lobCode, productName, quoteNumber }) {
  const [alerts, setAlerts] = useState([]);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const [saveQuoteDisplay, setSaveQuoteDisplay] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const mutateQuery = useMutationQuery();

  const [
    customerNameQuoteSaved,
    setCustomerNameQuoteSaved,
  ] = useState(null);
  let { loading, error, data: state } = useQuery(QUERY_STATE);
  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: businessTypeData,
  } = useQuery(CUSTOMER_DROPDOWN_DETAILS);
  const {
    loading: intermediaryListLoading,
    error: intermediaryListError,
    data: intermediaryListData,
  } = useQuery(INTERMEDIARY_LIST);

  const getDomainData = (
    domainArr,
    searchText, 
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  const getGraphQLErrorMessage = (error) => {
    //console.log(error);
    return error.graphQLErrors.length > 0
      ? error.graphQLErrors.map((gerr) =>
          gerr && gerr.message
            ? gerr.message
            : 'Internal Error Occurred',
        )[0]
      : error.message
      ? error.message
      : 'Internal Error Occurred';
  };

  const [
    doSaveQuote,
    { loading: saveLoading, error: saveError },
  ] = useMutation(SAVE_QUOTE, {
    onCompleted: (data) => {
      updateQuotationDetails(
        data.saveQuote.quoteNumber,
        data.saveQuote.status,
        data.saveQuote.quoteCreationDate,
      );
      updateHealthQuote({
        isQuoteSaving: false,
      });
      setAlerts([
        {
          header: 'Quote Save Success',
          id: Date.now(),
          content: (
            <div className="flex flex-col w-full h-full">
              <Text type="normal">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-success"
                />{' '}
                Quote Saved successfully for{' '}
                <span className="font-bold">
                  {customerNameQuoteSaved}
                </span>
              </Text>
              <Text type="normal">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-success"
                />{' '}
                Quotation Number: {data.saveQuote.quoteNumber}
              </Text>
            </div>
          ),
          type: 'success',
          timeout: null,
          disableClose: false,
        },
      ]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    //
    onError: (error) => {
      setAlerts([
        ...alerts,
        {
          header: 'Error',
          id: Date.now(),
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              {getGraphQLErrorMessage(error)}
            </div>
          ),
          type: 'error',
          timeout: null,
          disableClose: false,
        },
      ]);
    },
  });

  if (loading || loadingBusinessType || intermediaryListLoading)
  return <Loading />;
if (error || errorBusinessType || intermediaryListError)
  return <Error />;


  let { healthQuote, healthPlans, selectedIntermediary } = state;
  const { businessTypeList } = businessTypeData;
  const { myIntermediaries } = intermediaryListData;

  const getBase64Var = (healthQuote, plans) => {
    return {
      input: {
        quotationType: healthQuote?.quotationType,
        quoteCreationDate: healthQuote?.quoteCreationDate,
        intermediary :{     
          intermediaryCode: healthQuote?.intermediaryDetails?.code || 
          myIntermediaries? myIntermediaries?.find(
            (intermediary) => intermediary?.isSelected,
          )?.intermediaryCode :"",
        intermediaryName: healthQuote?.intermediaryDetails?.name ||
              myIntermediaries? myIntermediaries?.find(
                (intermediary) => intermediary?.isSelected,
              )?.intermediaryName :"",
          locationCode: '',
          fieldUserCode: '',
        },
        customer: {
          id: healthQuote?.customer?.id
            ? healthQuote?.customer?.id
            : healthQuote?.customer?.cust_number,
          customerType: healthQuote?.customer?.customerType
            ? healthQuote?.customer?.customerType
            : healthQuote?.customer?.cust_type?.code,
          // custCkyc: '123444',
          // panNo: 'BSAPG7676S',
          title: healthQuote?.customer?.title
            ? healthQuote?.customer?.title
            : healthQuote?.customer?.indv_detail?.title?.code,
          firstName: healthQuote?.customer?.firstName
            ? healthQuote?.customer?.firstName
            : healthQuote?.customer?.indv_detail?.first_name,
          middleName: healthQuote?.customer?.middleName
            ? healthQuote?.customer?.middleName
            : healthQuote?.customer?.indv_detail?.middle_name,
          lastName: healthQuote?.customer?.lastName
            ? healthQuote?.customer?.lastName
            : healthQuote?.customer?.indv_detail?.surname,
          fullName: healthQuote?.customer?.fullName
            ? healthQuote?.customer?.fullName
            : healthQuote?.customer?.indv_detail?.full_name,
          emailID: healthQuote?.customer?.emailID
            ? healthQuote?.customer?.emailID
            : healthQuote?.customer?.contact?.email,
          mobileNo: healthQuote?.customer?.mobileNo
            ? healthQuote?.customer?.mobileNo
            : healthQuote?.customer?.contact?.mobile,
          proposerDOB: healthQuote?.customer?.proposerDOB
            ? healthQuote?.customer?.proposerDOB
            : healthQuote?.customer?.indv_detail?.date_of_birth,
          orgName: healthQuote?.customer?.orgName
            ? healthQuote?.customer?.orgName
            : healthQuote?.customer?.org_detail?.org_name,
          orgType: healthQuote?.customer?.orgType
            ? healthQuote?.customer?.orgType
            : healthQuote?.customer?.org_detail?.org_type?.code,
          contactName: healthQuote?.customer?.contactName
            ? healthQuote?.customer?.contactName
            : healthQuote?.customer?.org_detail?.contact_name,
        },
        lob: lobCode,
        product: productCode,
        location: {
          pinCode: healthQuote?.location?.pincode,
          state: healthQuote?.location?.state,
          district: healthQuote?.location?.district,
          city: healthQuote?.location?.city,
          zone: healthQuote?.location?.zone,
        },
        policyNumber: healthQuote?.policyNumber,
        employeeNumber: healthQuote?.employeeNumber,
        members: healthQuote?.members
          .filter((mem) => mem.selected)
          .map((member) => {
            return {
              relationship: member?.relationship,
              gender: member?.gender,
              dob: member?.dob,
              age: member?.age.toString(),
            };
          }),
        cover: {
          type: healthQuote?.cover?.type,
          sumInsured: parseInt(healthQuote?.cover?.sum_insured),
          tenure: healthQuote?.cover?.tenure,
        },
        // plans: healthPlans?.plans.map((plan) => {
          plans: plans
          ?.filter((plan) => plan?.isSelected)
          ?.map((plan) => {
          return {
            name: plan?.name,
            code: plan?.code,
            covers: plan?.covers.map((cover) => {
              return { name: cover?.name, index: cover?.index };
            }),
            packs: plan?.packs.map((pack) => {
              return {
                name: pack?.name,
                index: pack?.index,
                addOnCovers: pack?.addOnCovers.map((addOn) => {
                  return {
                    name: addOn?.name,
                    index: addOn?.index,
                    selected: addOn?.selected,
                  };
                }),
              };
            }),
            premium: {
              basePremium: plan?.premium?.basePremium,
              loadingDiscount: plan?.premium?.loadingDiscount,
              netPremium: plan?.premium?.netPremium,
              gst: plan?.premium?.gst,
              stampDuty: plan?.premium?.stampDuty,
              totalPremium: plan?.premium?.totalPremium,
              loading: plan?.premium?.loading?.map((loading) => {
                return {
                  name: loading?.name,
                  amount: loading?.amount,
                };
              }),
              discount: plan?.premium?.discount?.map((discount) => {
                return {
                  name: discount?.name,
                  amount: discount?.amount,
                };
              }),
              breakup: plan?.premium?.breakup.map((brkup) => {
                return {
                  relationship: brkup?.relationship,
                  gender: brkup?.gender,
                  age: brkup?.age,
                  premium: brkup?.premium,
                };
              }),
            },
          };
        }),
       
        deductibleSumInsured:parseInt( healthQuote?.deductSumInsured ? healthQuote?.deductSumInsured : 0) ,
      fieldUserCode: selectedIntermediary?.fieldUserCode
      },
      quoteNumber: healthQuote?.quotationNo,
    };
  };

  const enableSave = () => {
    let premiumCalculated = 0;
    healthPlans.plans.forEach((plan) => {
  //     if (plan.premium) premiumCalculated = premiumCalculated + 1;
  //   });
  //   return (
  //     premiumCalculated !== 0 &&
  //     premiumCalculated === healthPlans.plans.length &&
  //     healthPlans.plansChanged.length === 0
  //   );
  // };
  if (plan.premium && plan.isSelected)
  premiumCalculated = premiumCalculated + 1;
});
return premiumCalculated !== 0;
};
  const getIntermediaryName = (code) => {
    return myIntermediaries
      ? myIntermediaries?.find(
          (intermediary) => intermediary?.intermediaryCode === code,
        )?.intermediaryName
      : code;
  };
  const getBusinessLocation = (intermediarycode, locationCode) => {
    return myIntermediaries && intermediarycode && locationCode
      ? myIntermediaries?.find(
          (intermediary) =>
            intermediary?.intermediaryCode === intermediarycode,
        )
        ? myIntermediaries
            ?.find(
              (intermediary) =>
                intermediary?.intermediaryCode === intermediarycode,
            )
            ?.businessLocations?.find(
              (location) => location?.code === locationCode,
            )?.name
        : locationCode
      : '';
  };
  const data = [
    {
      label: 'Business Type',
      text: getDomainData(
        businessTypeList,
        healthQuote?.quotationType,
        'code',
        'value',
      ),
    },
    healthQuote?.intermediaryDetails?.code ||
    selectedIntermediary?.intermediaryCode ||
    selectedIntermediary?.intermediaryName
      ? {
          label: 'Partner',
          text:
            healthQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode
              ? 

              `${getIntermediaryName(
                healthQuote?.intermediaryDetails?.code ||
                selectedIntermediary?.intermediaryCode,
              )} (${`${healthQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode
              }`})`
             
              : selectedIntermediary?.intermediaryName,
        }
      : undefined,
    // healthQuote?.intermediaryDetails?.location ||
    // selectedIntermediary?.branchOfficeCode ||
    // selectedIntermediary?.branchOfficeName
    //   ? 
    {
          label: 'Branch Office',
          text:
            healthQuote?.intermediaryDetails?.location ||
            selectedIntermediary?.branchOfficeCode
              ? getBusinessLocation(
                  healthQuote?.intermediaryDetails?.code ||
                    selectedIntermediary?.intermediaryCode,
                  healthQuote?.intermediaryDetails?.location ||
                    selectedIntermediary?.branchOfficeCode,
                )
              : selectedIntermediary?.branchOfficeName,
        },
    //   : undefined,
    // healthQuote?.intermediaryDetails?.fieldUserCode ||
    // selectedIntermediary?.fieldUserCode ||
    // selectedIntermediary?.fieldUserName
    //   ?
       {
          label: 'Field User',
          text:
            healthQuote?.intermediaryDetails &&
            healthQuote?.intermediaryDetails?.fieldUserCode &&
            healthQuote?.intermediaryDetails?.fieldUserCode !== '' ? (
              <GetFieldUserName
                {...{
                  code:
                    healthQuote?.intermediaryDetails?.fieldUserCode ||
                    selectedIntermediary?.fieldUserCode,
                }}
              />
            ) : healthQuote?.intermediaryDetails.code !== '' &&
              healthQuote?.intermediaryDetails?.fieldUserCode ===
                '' ? (
              ''
            ) : (
              selectedIntermediary.fieldUserName
            ),
        },
      // : undefined,
    {
      label: healthQuote.quotationNo ? 'Quotation Number' : undefined,
      text: healthQuote.quotationNo,
    },
    {
      label: healthQuote.proposalNumber
        ? 'Proposal Number'
        : undefined,
      text: healthQuote.proposalNumber,
    },
    {
      text: (
        <Button
          disabled={
            (healthQuote.quotationNo !== '' || healthQuote.currentTab === 'members')
              ? true
              : !enableSave() || saveLoading
          }
          size="medium"
          className="mt-2 w-full max-h-10"
          onClick={(_) => setSaveQuoteDisplay(true)}
          flat={true}
          iconPre={
            saveLoading ? (
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                className={`${
                  (
                    healthQuote.quotationNo !== ''
                      ? true
                      : !enableSave() || saveLoading
                  )
                    ? 'ml-4'
                    : 'ml-6'
                }`}
              />
            ) : saveError ? (
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                className={
                  (
                    healthQuote.quotationNo !== ''
                      ? true
                      : !enableSave() || saveLoading
                  )
                    ? 'ml-4'
                    : 'ml-6'
                }
              />
            ) : (
              <FontAwesomeIcon
                icon={faSave}
                className={
                  (
                    healthQuote.quotationNo !== ''
                      ? true
                      : !enableSave() || saveLoading
                  )
                    ? 'ml-4'
                    : 'ml-6'
                }
              />
            )
          }
        >
          {saveLoading ?`Saving...` :'Save Quote'}
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={healthQuote.quotationNo === '' ? true : true||loadingDownload}
          size="medium"
          className="mt-2 w-full max-h-10"
          flat={true}
          iconPre={
            <FontAwesomeIcon
              icon={faEnvelope}
              className={!enableSave() ? 'ml-4' : 'ml-6'}
            />
          }
          onClick={(e) => setShowEmail(true)}
        >
          Email Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={healthQuote.quotationNo === '' ? true : false||loadingDownload}
          size="medium"
          className="mt-2 w-full max-h-10"
          flat={true}
          iconPre={
            <FontAwesomeIcon
              icon={faSms}
              className={!enableSave() ? 'ml-4' : 'ml-6'}
            />
          }
          onClick={(e) => setShowSms(true)}
        >
            Message Quote
        </Button>
      ),
    },
    {
      text: (
        <Button
          disabled={
            healthQuote.quotationNo === '' || loadingDownload
              ? true
              : true
          }
          size="medium"
          className="mt-2 w-full max-h-10"
          flat={true}
          iconPre={
            <FontAwesomeIcon
              icon={loadingDownload ? faSpinner : faDownload}
              spin={loadingDownload}
              className={!enableSave() ? 'ml-4' : 'ml-6'}
            />
          }
          onClick={async (_) => {
            try {
              setLoadingDownload(true);
              let quotePDFBase64String = mutateQuery({
                mutation: SEND_QUOTE_PDF,
                variables: getBase64Var(healthQuote, healthPlans.plans),
              });
              
              let {
                data: dataBase64String,
              } = await quotePDFBase64String;
              const { sendQuotePDF } = dataBase64String;
              const {
                base64Pdf: downloadBase64String,
              } = sendQuotePDF;
              setLoadingDownload(false);
              let byteCharacters = atob(
                downloadBase64String.toString(),
              );
              let byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              let byteArray = new Uint8Array(byteNumbers);
              let file = new Blob([byteArray], {
                type: 'application/pdf;base64',
              });
              let fileURL = URL.createObjectURL(file);
              // window.open(fileURL);
              const downloadLink = document.createElement('a');
              const fileName = `${productName}-${healthQuote?.quotationNo}.pdf`;
              downloadLink.href = fileURL;
              downloadLink.download = fileName;
              downloadLink.click();
              window.URL.revokeObjectURL(fileURL);
            } catch (error) {
              setAlerts([
                {
                  id: Date.now(),
                  content: (
                    <div className="flex flex-col w-full h-full">
                      <Text type="normal">{error.message}</Text>
                    </div>
                  ),
                  type: 'error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
              setLoadingDownload(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          {loadingDownload ? 'Downloading...' : 'Download Quote'}
        </Button>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      <div className="pb-2">
        <DataGrid textType="normal" {...{ data }} repeat={1} />
      </div>
      <div>
        <ModalSaveQuote
          {...{
            saveQuoteDisplay,
            setSaveQuoteDisplay,
            setCustomerNameQuoteSaved,
            doSaveQuote,
            productCode,
            lobCode,
            selectedIntermediary,
          }}
        />
      </div>
      <NotificationList {...{ items: alerts }} />
      <ModalSendEmail
        {...{
          setShowEmail,
          showEmail,
          initialEmail: healthQuote?.customer?.emailID
            ? healthQuote?.customer?.emailID
            : healthQuote?.customer?.contact?.email,
          getPayLoad: (email, plans, ccEmailIds) => {
            return {
              ...getBase64Var(healthQuote, plans),
              email,
              ccEmailIds,
            };
          },
          SEND_EMAIL_QUERY: SEND_QUOTE_EMAIL_ALERT,
          productCode,
          productName,
          lobCode,
          quoteNumber,
          plans: healthPlans?.plans,
        }}
      />
      <ModalSendSms
        {...{
          setShowSms,
          showSms,
          initialMobile: healthQuote?.customer?.mobileNo
            ? healthQuote?.customer?.mobileNo
            : healthQuote?.customer?.contact?.mobile,
          getPayLoad: (
            mobile,
             plans,
              alternateMobileNos,
              whatsappNo,
              modes,
              ) => {
            return {
              ...getBase64Var(healthQuote, plans),
              mobile,
              alternateMobileNos,
               whatsappNo,
               modes,
                        };
          },
          SEND_SMS_QUERY: SEND_QUOTE_SMS_ALERT,
          productCode,
          productName,
          quoteNumber,
          plans: healthPlans?.plans,
        }}
      />
    </>
  );
}
